(() => {
  'use strict';
  if (window.__storeguard02) return;
  window.__storeguard02 = true;
  const script = document.currentScript;
  let api;
  try { api = new URL(script?.dataset.api).origin; if (new URL(api).protocol !== 'https:' && location.hostname !== 'localhost') return; } catch { return; }
  const key = 'sg_access_v2';
  let receipt = '', analytics = false, checking = false;
  function pass() {
    try { const p=JSON.parse(localStorage.getItem(key)||'null'); if(p?.expires>Date.now()/1000) return p.token; localStorage.removeItem(key); } catch {}
    try { return sessionStorage.getItem('sg_staff_session') || ''; } catch { return ''; }
  }
  function savePass(p) { try { localStorage.setItem(key, JSON.stringify({token:p.staffToken,expires:p.expires,kind:p.kind})); } catch { try {sessionStorage.setItem('sg_staff_session',p.staffToken);}catch{} } }
  function consent() {
    try { const p=window.Shopify?.customerPrivacy; if(typeof p?.analyticsProcessingAllowed==='function') return {analytics:p.analyticsProcessingAllowed()===true,source:'shopify'}; } catch {}
    return {analytics:false,source:'unavailable'};
  }
  function visitorId(allowed) {
    if (!allowed) {try{sessionStorage.removeItem('sg_visit_session');}catch{} return '';}
    try { let id=sessionStorage.getItem('sg_visit_session'); if(!id){id=crypto.randomUUID();sessionStorage.setItem('sg_visit_session',id);}return id;}catch{return '';}
  }
  function metadata(c) {
    let zone=''; try{zone=Intl.DateTimeFormat().resolvedOptions().timeZone;}catch{}
    return {path:location.pathname,referrer:c.analytics?document.referrer:'',consent:c,visitorId:visitorId(c.analytics),browser:c.analytics?{language:navigator.language,timezone:zone,viewport:innerWidth+'x'+innerHeight,screen:screen.width+'x'+screen.height}:undefined};
  }
  async function post(path, value) {
    const response=await fetch(api+path,{method:'POST',credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',headers:{'Content-Type':'application/json'},body:JSON.stringify(value),signal:AbortSignal.timeout(3500)});
    if(!response.ok)throw new Error('check unavailable');return response.json();
  }
  function block(result) {
    if(document.getElementById('traffic-guard-blocked'))return;
    const host=document.createElement('div');host.id='traffic-guard-blocked';host.setAttribute('role','dialog');host.setAttribute('aria-modal','true');host.setAttribute('aria-label','Connection restricted');
    Object.assign(host.style,{position:'fixed',inset:'0',zIndex:'2147483647',background:'#f6f8f7',color:'#182921',display:'grid',placeItems:'center',fontFamily:'system-ui,sans-serif',padding:'24px',overflow:'auto'});
    const box=document.createElement('div');box.style.maxWidth='510px';
    const title=document.createElement('h1');title.textContent='Connection restricted';
    const text=document.createElement('p');text.textContent=result.message;
    const reference=document.createElement('p');reference.textContent='Reference: '+result.reference;reference.style.overflowWrap='anywhere';
    const retry=document.createElement('button');retry.textContent='Try again';retry.onclick=()=>location.reload();
    const staff=document.createElement('button');staff.textContent='Staff access';staff.onclick=()=>{location.href=api+'/?store_access=1';};
    const help=document.createElement('p');help.textContent='Already have an access link from our store? Open that link in this browser. If you use a VPN, you can also try your regular connection.';
    for(const b of [retry,staff])Object.assign(b.style,{padding:'11px 18px',margin:'8px 8px 8px 0',background:'#163e30',color:'white',border:'0',borderRadius:'8px',cursor:'pointer'});
    box.append(title,text,reference,retry,staff,help);host.append(box);document.documentElement.append(host);
  }
  async function privacyReady() {
    if(window.Shopify?.customerPrivacy)return;
    await new Promise(resolve=>{
      const timer=setTimeout(resolve,1000);
      try{if(typeof window.Shopify?.loadFeatures==='function')window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>{clearTimeout(timer);resolve();});else{clearTimeout(timer);resolve();}}catch{clearTimeout(timer);resolve();}
    });
  }
  async function changed() {
    const c=consent();analytics=c.analytics;
    if(receipt)try{await post('/api/consent',{receipt,...metadata(c)});}catch{}
  }
  async function run() {
    if(checking)return;checking=true;
    try{
      const params=new URLSearchParams(location.hash.slice(1)),invite=params.get('sg_staff');
      if(invite){params.delete('sg_staff');history.replaceState(history.state,'',location.pathname+location.search+(params.size?'#'+params:''));try{savePass(await post('/api/redeem',{token:invite}));}catch{}}
      await privacyReady();const c=consent();analytics=c.analytics;
      const result=await post('/api/evaluate',{...metadata(c),passToken:pass()});receipt=result.receipt;
      if(result.decision==='block')block(result);
      if(consent().analytics!==analytics)await changed();
    }catch{}finally{checking=false;}
  }
  document.addEventListener('visitorConsentCollected',()=>{void changed();});
  document.addEventListener('click',e=>{
    if(!analytics||!receipt)return;
    const target=e.target instanceof Element?e.target:null;if(!target)return;
    const a=target.closest('a[href]'),button=target.closest('button,input[type=submit]');
    let kind='';
    if(a){try{const u=new URL(a.href,location.href);if(u.origin===location.origin&&/^\/checkout(?:\/|$)/.test(u.pathname))kind='checkout_intent';}catch{}}
    if(button?.name==='checkout')kind='checkout_intent';
    else if(button?.name==='add'||button?.closest('form[action*="/cart/add"]'))kind='add_cart_intent';
    if(kind)void post('/api/activity',{receipt,kind}).catch(()=>{});
  },{capture:true,passive:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>{void run();},{once:true});else void run();
})();
